import {PageConfigTypes} from "app/types/PageTypes";
import EmployeesList from "./employees-list/EmployeesList";
import {ROLES} from "app/constants/roles";
import CreateEmployeeForm from "./create/CreateEmployeeForm";
import EmployeesPage from "./EmployeesPage";
import OnlineUsersList from "./online-users/OnlineUsersList";

const EmployeesPageConfig: PageConfigTypes = {
    baseRoute: {
        path: "/employees",
        component: EmployeesPage,
        authorities: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER]
    },
    subRoutes: [
        {
            path: '/employees/employees-list',
            component: EmployeesList
        },
            {
        path: '/employees/online-users',
        component: OnlineUsersList
    },

    ],
      settings: {
         quickPanel: {
            create: {
                path: "/employees/list/create",
                component: CreateEmployeeForm,
            },
        },
    navbar: {
            open: true,
     title: "app.main.employees.sidebar.title",
    subtitle: "app.main.employees.sidebar.subtitle",
    items: [
      {
        to: "/list",
        primaryText: "app.main.employees.sidebar.items.all",
        icon: "play_arrow",
        exact: true,
      },
      {
        to: "/online-users",
        primaryText: "app.main.employees.sidebar.items.online",
        icon: "play_arrow",
        exact: true,
      },
    ],
        },
      },
    };



export default EmployeesPageConfig;